import {
  Button,
  Container,
  Content,
  Frame,
  Icon,
  Stack,
} from '@kinesis/bungle';
import { Center } from '@/components/center';
import { useLogoutMutation } from '@/api/login';
import {
  ButtonSpacer,
  Heading,
  IconSpacer,
  Panel,
  Text,
} from './no-products.styles';

// Shown after login when the user's organisation has no licensed products, so
// there is nowhere to land. doorway returns the no-products target in this
// case; launch() routes here rather than dead-ending on a product that isn't
// available to them. Gray background (like the error pages), not the brand
// background used for the login/registration flows.
const NoProducts = () => {
  const [logout] = useLogoutMutation();

  return (
    <Container>
      <Frame>
        <Content sizing='fill-container' height='100%' background='gray'>
          <Center>
            <Panel>
              <Stack space='small'>
                <IconSpacer>
                  <Icon magnitude='xxlarge' type='exclamation-circle' />
                </IconSpacer>
                <Heading>No products available</Heading>
                <Text>
                  Your account isn’t licensed for any products yet. Ask your
                  organisation’s administrator to enable a product, or get in
                  touch with our support team.
                </Text>
                <ButtonSpacer>
                  <Button
                    onClick={() => {
                      logout();
                    }}
                  >
                    Log out
                  </Button>
                </ButtonSpacer>
              </Stack>
            </Panel>
          </Center>
        </Content>
      </Frame>
    </Container>
  );
};

export { NoProducts };
